import React from 'react';
import { LockIcon, ShieldCheckIcon, SmartphoneIcon, ZapIcon } from 'lucide-react';
type TrustStripProps = {
  className?: string;
  /** 'short' is the 3-item strip under a CTA, 'full' adds the digital-format item. */
  variant?: 'short' | 'full';
};
const SHORT = [{
  Icon: ShieldCheckIcon,
  label: '7-Day guarantee'
}, {
  Icon: LockIcon,
  label: 'Secure payment'
}, {
  Icon: ZapIcon,
  label: 'Instant access'
}];
const FULL = [{
  Icon: LockIcon,
  label: 'Secure payment'
}, {
  Icon: ZapIcon,
  label: 'Instant access'
}, {
  Icon: ShieldCheckIcon,
  label: '7-Day guarantee'
}, {
  Icon: SmartphoneIcon,
  label: '100% Digital'
}];
export function TrustStrip({
  className = '',
  variant = 'short'
}: TrustStripProps) {
  const items = variant === 'full' ? FULL : SHORT;
  return <ul className={`flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5 text-[10px] font-medium uppercase tracking-[0.14em] text-muted sm:text-[11px] ${className}`} data-id="element-179" data-mp="3us9cd95m2hm2">
      {items.map(({
      Icon,
      label
    }) => <li key={label} className="flex items-center gap-1.5" data-id="element-180" data-mp="3msbdpjh431sy">
          <Icon className="h-3 w-3 text-champagne" strokeWidth={1.75} aria-hidden="true" data-id="element-181" data-mp="3rro4gfb3st0t" />
          {label}
        </li>)}
    </ul>;
}